export default __webpack_public_path__ + "static/media/100-death-assurance.322d3bad.svg";